export class FAQ {
    question: string;
    answers: string[];
    constructor(question: string, answers: string[]) {
        this.question = question;
        this.answers = answers;
    }

    getQuestion() {
        return this.question;
    }

    getAnswers() {
        return this.answers;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/faq/faq.model.ts